<template>
  <div id="GoodsLists">
    <div style="padding: 20px">
      <van-empty
        v-if="goodsLists.length == 0"
        class="custom-image"
        :image="require('@/assets/images/empty-image.png')"
        description="这里什么都没有"
      />
    </div>
    <van-list
      v-model:loading="loading"
      :finished="finished"
      :finished-text="finishedText"
      @load="onLoad"
    >
      <van-card
        v-for="(item, index) in goodsLists"
        :key="index"
        :tag="item.isPromotion ? '促销' : ''"
        :thumb="item.thumb"
        :title="item.goodsName"
        :desc="item.goodsDesc"
      >
        <template v-if="item.isPromotion" #origin-price>
          ¥{{ item.originPrice.toFixed(2) }}
        </template>
        <template #footer>
          <van-button
            type="primary"
            size="mini"
            @click="onMiniProgramQrcode(item)"
            >获取小程序二维码</van-button
          >
        </template>
      </van-card>
    </van-list>
    <van-dialog v-model:show="qrcodeShow" :title="qrcodeTitle">
      <center><van-image :src="miniProgramQrcode"></van-image></center>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'GoodsLists',
  props: ['shopId', 'categoryId'],
  data() {
    return {
      qrcodeShow: false,
      qrcodeTitle: '',
      miniProgramQrcode: '',
      loading: false,
      finished: false,
      pageNumber: 1,
      pageSize: 20,
      keywords: '',
      goodsLists: [],
    }
  },
  created() {
    this.getGoodsLists()
  },
  methods: {
    getGoodsLists() {
    this.$axios
      .post(
        this.$axios.defaults.baseURL + '/market/goods/lists',
        {
          shopId: this.shopId,
          categoryId: this.categoryId,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          keywords: this.keywords,
        },
        {}
      )
      .then((response) => {
          let rows = response.data.data.items //请求返回当页的列表
          this.loading = false
          this.total = response.data.data.total
          if (rows == null || rows.length === 0) {
            // 加载结束
            this.finished = true
            this.finishedText = '——————我是有底线的——————'
            return
          }
          // 将新数据与老数据进行合并
          this.goodsLists = this.goodsLists.concat(rows)
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.pageNumber == response.data.data.pages) {
            this.finished = true
            this.finishedText = '——————我是有底线的——————'
          }
      })
      .catch((error) => {
        if (error.response) {
          this.$toast(error.response.data.message)
        } else if (error.request) {
          if (error.request.status == 0) {
            this.$toast('服务器溜号了，赶快召唤神龙大侠阿宝～')
          }
        } else {
          console.log('Error', error.message)
        }
      })
    },
    onLoad() {
      this.pageNumber++
      this.getGoodsLists()
    },
    onMiniProgramQrcode(item) {
      this.qrcodeTitle = item.goodsName
      this.miniProgramQrcode = item.miniProgramQrcode
      this.qrcodeShow = true
    },
  },
}
</script>